import { useSyncExternalStore } from 'react';
import type { FlagName } from '../store/types';
import { useFeatureFlagStore } from './FeatureFlagContext';

export function useFeatureFlag(key: FlagName, defaultValue = false): boolean {
  const store = useFeatureFlagStore();

  return useSyncExternalStore(
    store.subscribe,
    () => {
      const value = store.getFlag(key);
      return value === undefined ? defaultValue : value === true;
    },
    () => defaultValue,
  );
}
